import { createContext } from "react"
import type { GridInitialState, GridColumnDimensions } from "@mui/x-data-grid-premium"

export type DatagridPersistenceState = Record<string, GridInitialState> & {
  shared?: {
    labelDimensions?: GridColumnDimensions
  }
}

export interface DatagridPersistenceSource {
  datagridState: DatagridPersistenceState | undefined
  setDatagridState: (state: DatagridPersistenceState) => void
}

// Feature-agnostic injection point for ContributorsDataGrid persistence. Each feature
// (asset-view, factors-view) provides its own slice-backed source, so the shared renderer
// never hardcodes one feature's store. Absent provider → persistence disabled.
export const DatagridPersistenceContext = createContext<DatagridPersistenceSource | null>(null)
